import React from "react";
import Footer_m from '../footer/Footer.js';
import Header_m from '../header/Header.js';
import BaseTamplate from "../Template/Template.js";
import CementBanner from '../../img/banners/cement.jpg';
// ..........................
import backyard from '../../img/concrete/backyard.jpg';
import backyard2 from '../../img/concrete/backyard2.jpg'
import corner from '../../img/concrete/corner.jpg';
import frontyard from '../../img/concrete/frontyard.jpg'
import driveway from '../../img/concrete/driveway.jpg';
import driveway2 from '../../img/concrete/driveway2.jpg'

import ServiceList from "../Template/ServiceList.js";


let pictureArray = [backyard, backyard2, corner, frontyard, driveway, driveway2];

let whatWeDo = ['Driveways', "Porch", "Patios", "Constructions", "Renovation"];


const Concrete = () => {
    return (
        <div>
            {/* <Header_m></Header_m> */}
            {/* Actual code for the page */}

            <div className="container">

                <BaseTamplate pageName="Concrete" pictures={pictureArray} Title='Concrete' itemList={whatWeDo}>
                    {CementBanner}
                </BaseTamplate>

            </div>
            {/* The footer */}
            <Footer_m></Footer_m>
        </div>
    )

}

export default Concrete;


